// src/admin/api/adminApiError.js
//
// Error normalization shared by the admin/ API modules (permissions, roles,
// users). Builds on getApiError from api/client.js rather than re-deriving
// the message: that already collapses all three `detail` shapes the backend
// can produce — a plain string, FastAPI's validation array of {loc, msg,
// type}, and architecture_scaffold's domain-exception object of {code,
// message, context, correlation_id} — down to one string. Rendering the raw
// object instead is what produces "Objects are not valid as a React child".
//
// What this adds on top is `fieldErrors`: the shape the form modals branch on
// (see accounts/components/RegisterAccountModal.jsx) so a conflict lands
// inline under the offending input instead of in a detached banner.

import { getApiError } from "../../api/client";

/**
 * Normalizes an axios failure into an Error an admin modal can render.
 *
 * `fieldName` names the single unique column the endpoint can conflict on —
 * a permission's or role's `name`. A 409 Conflict or 422 Validation there is
 * almost always about that field, so it's attached as `fieldErrors` and shown
 * against the input. Every other status stays a plain message.
 */
export function toAdminError(err, fallback = "Request failed.", fieldName = null) {
  const status = err?.response?.status;
  const normalized = new Error(getApiError(err) || fallback);
  normalized.status = status;

  if (fieldName && (status === 409 || status === 422)) {
    normalized.fieldErrors = { [fieldName]: normalized.message };
  }

  return normalized;
}
